export enum NumbersConfigEnum {
    Active,
    Buy
}